class UserDetailsVM {
    userInitials: string;
    username: string;
    userProfile: string;
    userOrganization: string;
    version: string;
    date: string;

    constructor(data: any) {
        this.userInitials = data.userInitials;
        this.username = data.username;
        this.userProfile = data.userProfile;
        this.userOrganization = data.userOrganization;
        this.version = data.version;
        this.date = data.date;
    }
}